
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCommonHealthRecord} from "@/models/app/common/health-record";

// Components
import {
  ElDialog,
  ElButton,
} from "element-plus";
import {Paperclip} from "@element-plus/icons-vue";

@Options({
  props: [
    "healthRecord",
  ],
  components: {
    ElDialog,
    ElButton,
    Paperclip,
  },
})
export default class CoachPlayersProfileHealthRecordsListFormLookupDocumentIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  healthRecord: AppCommonHealthRecord = new AppCommonHealthRecord();

  $refs!: {
    formComponent: HTMLFormElement;
  };
}
